export function wsBaseUrl(): string {
  if (typeof window === 'undefined') return 'ws://localhost:9000';
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  // backend runs on port 9000 in dev; in prod assume same origin. speak (:9003)
  // y scout (:9004) no entran acá: usan el proxy same-origin de su vite.config.
  const isDevPort = window.location.port === '5173';
  if (isDevPort) return `${proto}//${window.location.hostname}:9000`;
  return `${proto}//${window.location.host}`;
}
